import { render, staticRenderFns } from "./VFavourites.vue?vue&type=template&id=ede8e846&"
import script from "./VFavourites.vue?vue&type=script&lang=js&"
export * from "./VFavourites.vue?vue&type=script&lang=js&"
import style0 from "./VFavourites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports